import { z } from 'zod';

export const MatchGridColumnConfigFormSchema = z.object({
  order: z.array(z.string()),
  shown: z.record(z.string(), z.boolean()),
});

export type MatchGridColumnConfigForm = z.infer<
  typeof MatchGridColumnConfigFormSchema
>;
